import React from 'react';
import { Link } from 'react-router-dom';

export default function Footer() {
  return (
    <footer className="border-t border-white/10 py-8 mt-auto">
      <div className="max-w-6xl mx-auto px-4 md:px-6">
        <div className="flex flex-col items-center gap-3 text-center">
          <Link to="/privacy" className="text-white/60 hover:text-white transition text-sm">
            Privacy
          </Link>
          
          <span className="text-white/60 text-sm">
            VindJouwBandLid.nl is een initiatief van{' '}
            <a href="https://tapsody.app" className="text-[#8146FF] hover:underline">Tapsody App</a>
            {' '}- KvK: 42033957, Rotterdam, Nederland.
          </span>

          <span className="text-white/60 text-sm">
            Gemaakt in de EU.
          </span>
          
          <span className="text-white/60 text-sm">
           Copyright © {new Date().getFullYear()} VindJouwBandLid.nl
          </span>
        </div>
      </div>
    </footer>
  );
}
